import Icon from 'components/misc/Icon'
import styled from 'styled-components'

function getColor(props, color, fallback) {
  return props.theme.colors[color] || color || fallback
}

export  default styled(Icon).attrs({ symbol: 'chevron-divider' })`
  .right {
    fill: ${props => getColor(props, props.right, props.theme.colors.black)};
  }

  .left {
    fill: ${props => getColor(props, props.left, props.theme.colors.black)};
  }

  .divider {
    fill: ${props => getColor(props, props.divider, props.theme.colors.white)};
  }
`